export default class ApiOutboundPaymentInitRequest {
    constructor(paymentReference, paymentPartner, clientPlatform) {
        this.paymentReference = paymentReference;
        this.paymentPartner = paymentPartner;
        this.clientPlatform = clientPlatform;
    }

}